import React from 'react';
import { Dialog, DialogContent, DialogTitle, useMediaQuery, useTheme } from '@mui/material';

import FormComprovantes from './FormComprovantes';

function DialogComprovantes({ open, onClose, ...props }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth fullScreen={isMobile}>
            <DialogTitle
                sx={{
                    bgcolor: '#f5f5f5',
                    color: '#222',
                    fontWeight: 700,
                    borderBottom: '1px solid #ddd',
                }}
            >
                Comprovantes do Lançamento
            </DialogTitle>

            <DialogContent dividers>
                <FormComprovantes onClose={onClose} {...props} />
            </DialogContent>
        </Dialog>
    );
}

export default DialogComprovantes;
